import React, { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useDialog } from "../../../contexts/DialogContext";
import { getTimeStamp } from "../../../utils/common";
import { useTranslation } from "react-i18next";
import useMainContentDimensions from "../../../utils/mainContentDimensions";

import {
  Card,
  CardHeader,
  Breadcrumbs as MuiBreadcrumbs,
  Paper as MuiPaper,
  Button,
  Typography,
  CardContent,
} from "@mui/material";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import Toolbar from "../../../components/Toolbar";
import useWindowDimensions from "../../../utils/windowDimensions";
import AdvanceFilter from "../../invoices/paid_invoices/components/AdvanceFilter";
import usePaidInvoice from "../../../hooks/usePaidInvoice";
import EditDelete from "../../../components/EditDelete";
import ReceiptForm from "../../users/user_details/ReceiptPage";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);

function Receipts(props) {
  const [options, setOptions] = useState(["receipt"]);
  let [searchParams, setSearchParams] = useSearchParams();
  const { width: mainContentWidth } = useMainContentDimensions();

  const userId = searchParams.get("id");

  console.log(userId, "i am here");

  const { state } = useLocation();
  const { t } = useTranslation();

  const currentPayload = {
    filters: [
      {
        fieldName: "radUserId",
        fieldValue: userId,
        op: "eq",
        dataType: "int",
        condition: "and",
        isJoin: true,
        attributeName: "radUser",
        entityName: "RadUserEntity",
      },
    ],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [
      {
        field: "createdAt",
        sort: "DESC",
      },
    ],
  };

  const [sortModel, setSortModel] = useState([
    {
      field: "updatedAt",
      sort: "desc",
    },
  ]);
  const { height } = useWindowDimensions();
  const { getAllReceipts, receipts, paging, downloadReceipts } = usePaidInvoice();
  const { openDialog } = useDialog();

  console.log(paging, "receiptsreceipts");

  const [payload, setPayload] = useState(currentPayload);

  const [filterResetFunc, setFilterResetFunc] = useState(
    () => () => console.log("Refresh initialized"),
  );

  const fetchData = async () => {
    await getAllReceipts(payload);
  };

  const refreshPage = () => {
    setPayload(currentPayload);
    filterResetFunc();
  };

  const onPageChange = (page) => {
    console.log(page, "pagepage");
    const pagination = {
      pageNumber: page == 0 ? 1 : page + 1,
      pageSize: payload.pagination.pageSize,
    };
    setPayload((prev) => ({ ...prev, pagination }));
  };

  const breadCrump = () => {
    return (
      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Typography>Receipts</Typography>
      </Breadcrumbs>
    );
  };

  useEffect(() => {
    console.log(payload, "payloadpayload");
    fetchData();
  }, [payload, userId]);

  const handleSortModelChange = (newModel) => {
    console.log(newModel, "newModel");
    if (newModel.length !== 0) {
      setSortModel(newModel);
      setPayload((prev) => ({ ...prev, sortFields: newModel }));
    }
  };

  const viewReceipt = (renewId, title) => {
    return openDialog(
      "receipt",
      "Receipt",
      <ReceiptForm key={getTimeStamp()} renewId={renewId} />,
      "md",
    );
  };

  const columns = [
    {
      field: "action",
      headerName: "Action",
      filter: false,
      sortable: false,
      renderCell: (params) => {
        const onClick = (e) => {
          e.stopPropagation(); // don't select this row after clicking
          const api = params.api;
          const thisRow = {};
          api
            .getAllColumns()
            .filter((c) => c.field !== "__check__" && !!c)
            .forEach((c) => (thisRow[c.field] = params.getValue(params.id, c.field)));
          console.log(thisRow, "thisRow");
        };
        return (
          <EditDelete rowClick={onClick} menus={options} rowId={params.id} editPage={viewReceipt} />
        );
      },
    },
    {
      field: "receiptDate",
      headerName: "Receipt Date",
      width: 150,
    },
    {
      field: "receiptNo",
      headerName: "Receipt No",
      width: 150,
    },
    {
      field: "planName",
      headerName: "Plan Name",
      width: 300,
    },
    {
      field: "rateFullName",
      headerName: "Rate Full Name",
      width: 200,
    },

    {
      field: "finalInvoiceAmount",
      headerName: "Amount",
      width: 90,
    },
  ];

  const openFilterDialog = () => {
    return openDialog(
      "advance_filter",
      "Advance Filter",
      <AdvanceFilter
        payload={payload}
        setPayload={setPayload}
        setFilterResetFunc={setFilterResetFunc}
      />,
    );
  };

  return (
    <Card sx={{ width: "100%" }}>
      <CardHeader
        action={
          <Toolbar
            downloadFile={(type) => downloadReceipts(type, payload)}
            refreshPage={fetchData}
          />
        }
        title={t("receipts")}
      />

      <CardContent sx={{ height: height - 180 }}>
        <DataGrid
          columns={columns}
          rows={receipts}
          refreshPage={fetchData}
          getRowId={(row) => row["renewId"]}
          rowCount={paging.totalNumberOfRecords}
          loading={false}
          rowsPerPageOptions={[5]}
          pagination
          page={paging.pageNumber}
          pageSize={paging.pageSize}
          paginationMode="server"
          onPageChange={(page) => onPageChange(page)}
          onPageSizeChange={(pageSize) => onPageChange(pageSize)}
          sortingMode="server"
          sortModel={sortModel}
          onSortModelChange={handleSortModelChange}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row"
          }
          sx={{
            "& .MuiDataGrid-row.even-row": {
              backgroundColor: "#f9f9f9", // Light gray for even rows
            },
            "& .MuiDataGrid-row.odd-row": {
              backgroundColor: "#ffffff", // White for odd rows
            },
          }}
        />
      </CardContent>
    </Card>
  );
}

export default Receipts;
